/**
 * Border Radius Tokens - Atlas Design System
 * Updated for Globalsyde Atlas design spec
 */

export const baseBorderRadius = {
  none: 0,
  xs: 2,      // Tight elements (badges)
  sm: 6,      // Buttons, tags, small elements (Atlas spec)
  md: 8,      // Inputs
  lg: 12,     // Cards, main containers (Atlas spec)
  xl: 16,     // Dialogs, large surfaces
  full: 9999, // Pills, circular avatars
} as const;
